export default __webpack_public_path__ + "static/media/login-page.7e4d54d3.png";